import { gql } from '@utils/gpl-dedup';
import { userFragment } from '@graphql/users/fragments';

export const me = gql`
  {
    me {
      id
      ...user
    }
  }
  ${userFragment}
`;
